<section class="mb-5">
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.SP.TITLE" | translate }}
      </h4>
    </div>
    <div class="card-body">
      <p>
        {{ "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.SP.EXPLANATION" | translate }}
      </p>
      <div class="table-responsive">
        <table class="table white-text pe-none mt-3">
          <thead>
          <tr class="table-row table-row-head">
            <th scope="col">CEFR Level<sup>1</sup></th>
            <th scope="col">Callan stages</th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr class="table-row">
            <td>A1</td>
            <td>1/2</td>
          </tr>
          <tr class="table-row">
            <td>A2</td>
            <td>3/4</td>
          </tr>
          <tr class="table-row">
            <td>B1</td>
            <td>5/6</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ol class="text-muted ps-3">
        <li>
          <p class="fw-bold small mb-1">
            {{
            "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.EN.EXAMINATIONS_LIST.CEFR.TITLE"
              | translate
            }}
          </p>
          <p class="xsmall">
            {{
            "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.EN.EXAMINATIONS_LIST.CEFR.DESC"
              | translate
            }}
          </p>
        </li>
      </ol>
    </div>
  </div>
</section>

<section class="mb-5">
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">{{ "COL.COURSES.PRODUCTS.HOW_LONG.TITLE" | translate }}</h4>
    </div>
    <div class="card-body">
      {{ "COL.COURSES.PRODUCTS.HOW_LONG.DESC" | translate }}
      <div class="table-responsive">
        <table class="table white-text pe-none mt-3">
          <thead>
          <tr class="table-row table-row-head">
            <th scope="col">
              {{ "COL.COURSES.PRODUCTS.HOW_LONG.STAGE" | translate }}
            </th>
            <th scope="col">1</th>
            <th scope="col">2</th>
            <th scope="col">3</th>
            <th scope="col">4</th>
            <th scope="col">5</th>
            <th scope="col">6</th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr class="text-muted table-row">
            <th scope="row" class="xsmall">
              {{ "COL.COURSES.PRODUCTS.HOW_LONG.N_LESSONS" | translate }}
            </th>
            <td class="xsmall">30-35</td>
            <td class="xsmall">35-40</td>
            <td class="xsmall">40-45</td>
            <td class="xsmall">50-55</td>
            <td class="xsmall">50-55</td>
            <td class="xsmall">50-55</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<section class="mb-5">
  <p class="text-center mb-5 h4">
    {{ "COL.COURSES.PRODUCTS.PROGRESS.TITLE" | translate }}
  </p>
  <div class="row text-center justify-content-center">
    <div class="col-12 col-md-6 col-xl-4">
      <p>{{ "COL.COURSES.PRODUCTS.PROGRESS.EN.FREQUENCY.TITLE" | translate }}</p>
      <p class="text-muted">
        {{ "COL.COURSES.PRODUCTS.PROGRESS.EN.FREQUENCY.DESC" | translate }}
      </p>
    </div>
    <div class="col-12 col-md-6 col-xl-4">
      <p>{{ "COL.COURSES.PRODUCTS.PROGRESS.EN.CONNECTION.TITLE" | translate }}</p>
      <p class="text-muted">
        {{ "COL.COURSES.PRODUCTS.PROGRESS.EN.CONNECTION.DESC" | translate }}
      </p>
    </div>
    <div class="col-12 col-md-6 col-xl-4">
      <p>{{ "COL.COURSES.PRODUCTS.PROGRESS.EN.EXERCISES.TITLE" | translate }}</p>
      <p class="text-muted">
        {{ "COL.COURSES.PRODUCTS.PROGRESS.EN.EXERCISES.DESC" | translate }}
      </p>
    </div>
  </div>
</section>
